import React, { useState, useEffect, useRef } from 'react';
import style from './PrescriptionCheck.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import URL from '../../../../constants/url';
import { Link, useNavigate } from 'react-router-dom';
import imgPrinter from '../../../../images/user/i_printer.svg';
import imgSample from '../../../../images/user/img_sample_prescription.png';


const PrescriptionCheck = () => {

    const navigate = useNavigate();

    
    return (
        <>
            <HeadSub title="처방전 확인" iconClose/>

            <div id="sub-content" data-layout="white">     
                <div className={style['top-notibox']}>
                        <p>보건복지부 정책에 따라 처방전은 저장할 수 없습니다.</p>
                    </div>
                <div className='inner-wrap'>
                    
                   {/* 처방전이 없을때 */}
                   {/* <div className={style['mid-box']} data-page='no-data'>
                        <div className='animation-2'>
                            <div className={style['mid']}>
                                <object data={imgPrinter} alt="" />
                            </div>
                            <div className={style['botm']}>
                                <strong>아직 처방전이 생성되지 않았습니다</strong>
                                <span>진료 종료 후 00분 ~ 00분정도 소요됩니다.</span>
                            </div>
                        </div>
                    </div> */}

                    <>
                        <div className={style['mid-box']} data-page='no-data'>
                            <div className='animation-2'>
                                <div className={style['mid']}>
                                    <object data={imgPrinter} alt="" />
                                </div>
                                <div className={style['botm']}>
                                    <strong>처방전이 생성되었습니다</strong>
                                    <span>근처 약국을 검색해 보세요.</span>
                                </div>
                            </div>
                        </div>    
                        

                        <div className="bottom-fixed-box">
                            <div className="inner-box">
                                <div className='btn-layout' data-btn-num="1"> 
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={()=> navigate(URL.HOSPITAL_PHARMACYFIND)}>
                                        <span>근처 약국 찾기</span>
                                    </button>
                                </div>
                            </div>
                        </div>       
                    </>        
                    

                </div>
            </div>
            
        </>
    );
};

export default PrescriptionCheck;
